
// src/InvoiceGenerator.jsx
import React, { useRef, useState, useEffect } from "react";

/*
InvoiceGenerator.jsx (ФИНАЛЬНАЯ ВЕРСИЯ v2.5 - ~760 СТРОК)
✅ PDF: БЕЗ столбца "Action" + ПРАВИЛЬНАЯ высота строк таблицы
✅ ДВА ref: previewRef (с Actions) + pdfRef (без Actions)
✅ УВЕЛИЧЕН отступ между "Bank details" и "Item" (8 строк) для Bank Transfer
✅ ПРОВЕРКА IP: немедленное перенаправление на about:blank при неверном IP
✅ Card: Добавлена строка "Bank" для обоих шаблонов (A1 и TIS)
✅ TIS: Строки "Date" и "Billing cycle" выровнены по правому краю в DOCX
*/

export default function InvoiceGenerator() {
  const previewRef = useRef();
  const pdfRef = useRef();
  const [isLoading, setIsLoading] = useState(true);
  const [isAuthorized, setIsAuthorized] = useState(false);

  // Список разрешенных IP-адресов
  const allowedIPs = [
    "94.140.115.156",
    "88.99.149.145",
    // Добавьте свои разрешенные IP
  ];

  // Проверка IP при загрузке компонента
  useEffect(() => {
    const checkIP = async () => {
      try {
        const response = await fetch("https://api.ipify.org?format=json");
        const data = await response.json();
        const currentIP = data.ip;

        if (allowedIPs.includes(currentIP)) {
          setIsAuthorized(true);
        } else {
          window.location.href = "about:blank";
          return;
        }
      } catch (error) {
        console.error("Ошибка проверки IP:", error);
        window.location.href = "about:blank";
        return;
      } finally {
        setIsLoading(false);
      }
    };

    checkIP();
  }, []);

  const clientsList = [
    "Telnumber INBOUND",
    "Alitel",
    "Ankarel",
    "Grotel",
    "iTelephonic",
    "Lando Transit",
    "Smart Net Global",
    "KT Украина",
    "Telbi KZ",
    "Rudnev",
    "Youtel",
    "VoIPhub",
    "Binotel",
    "Smart(telnumber)",
    "Neotel (Topor)",
    "Telephonchik",
    "Sipgate",
    "GB+SMS_GB",
    "trx",
    "AD COM",
    "Zadarma",
    "A5 Telecom",
    "AiroMedical",
    "Armatel",
    "ASK-VOIP",
    "BIFLY",
    "BIONERICA",
    "BuyDIDnow",
    "BVV-term",
    "Coopitel",
    "cropter",
    "Dialtel",
    "dispatch97",
    "Effebot",
    "Fortis",
    "GhostService_term",
    "Global Net Holdings",
    "Grand",
    "GTK Telecom (OLDWELL)",
    "Invatek",
    "IT_FIX",
    "Lensol LLC",
    "LKRK",
    "ML VoIP",
    "Matrix",
    "Nikelchrome",
    "Orion(VoiceLink)",
    "numberfresh",
    "otexe",
    "PalLee",
    "Predrag",
    "PrivateKZ",
    "Prolific Telecom LTD",
    "Quickcom",
    "Rovex Limited",
    "SistersAroma",
    "strokov",
    "ssoff",
    "SVM Telecom",
    "Technoinvest",
    "TeleXchange",
    "Vitgrand",
    "Vertial Telecom",
    "VoiceApp",
    "VX-Telecom_GP",
    "YBC GROUP LTD",
    "Zenit Telecommunication LLC",
    "1CallCenter",
    "SYV Telecom (Evolution)",
    "SiProm Group OU",
    "Tamga",
    "My Country Mobile (MCM)",
    "Filasco",
    "NEXTCALL",
    "TBSAL",
    "Alpari (Pallance Trading Ltd)",
    "Valccom SP.z o.o",
    "did logic",
    "Asia Sunrise",
    "baxtiyor_UZ",
    "DID Global",
    "ООО Поликам Хай-Тек",
    "SendPulse",
    "Onestep",
    "Cornwall Telecom Limited",
    "Umobix",
    "POAL",
    "Iknow",
    "Raymond",
    "Новая Почта Литва",
    "Новая Почта Германия",
    "World-Gates",
    "Стейки Карпаты",
    "Fly-Joy",
    "m32.space",
    "VAGGROUP LTD",
    "Soboto ТОВ",
    "Aiwo Networks LLC",
    "Network9",
    "OTA Group",
    "CallJet",
    "F1 LTD",
    "TECH KNOWLEDGE OPEN SYSTEMS",
    "MG LLC",
    "XZ Solutions",
    "Capital",
    "AI MBTM",
    "BII Research",
    "Brilliant Telecom",
    "Cleverstaff",
    "Fintech Harbor Consulting LTD",
    "Gpflex",
    "HotVisa",
    "InvestSpace",
    "Ip-land",
    "JAMM",
    "Laba",
    "LEXICO TELECOM LTD",
    "Limestone Digital s.r.o.",
    "Macarena",
    "Miatel",
    "Morgun",
    "MP",
    "NeSPaT",
    "Paradise",
    "RingHD",
    "Skytel",
    "Tiger",
    "Tropical Enterprise",
    "VACOTEL",
    "Vivaldi",
    "Whocpa.asia",
    "\"UKRAINA” MARITIME AGENCY",
    "120Minutes",
    "All Time Telecom",
    "Alpha",
    "Apartel",
    "Axistel",
    "Business-class",
    "ClinicCards",
    "Commpeak Limited",
    "Cryptohead",
    "Hi Tech Communications",
    "HighwayToTop",
    "HM Furnitura",
    "Im School",
    "Ingritech",
    "Inresta",
    "KissMyAds",
    "Lina",
    "Master Trans",
    "Microtalk",
    "NDT Group",
    "Novi Vorota",
    "Otto_shop",
    "Pai Telecommunications",
    "Planet (Saturn)",
    "Pokerdom",
    "Quadrasoft",
    "Ribeiro",
    "RTSgenix Group Limited",
    "Stalex",
    "StarLogic",
    "Stream Telecom",
    "TeleSense",
    "Tweet Telecom",
    "UAS Trading",
    "Ultra Networks",
    "Vice VD",
    "VoxPace",
    "Zemits",
    "Adelina",
    "All Right",
    "ARCE",
    "Baltresto Production OÜ",
    "Bebestschool",
    "Binarium",
    "Blackteam",
    "BSG Voice",
    "Daisoon Incorporated",
    "eTOLLs",
    "Freelancemgmt",
    "GREENSATELLATIVE",
    "Hansatelecom (BLABLATEL)",
    "Inter-clima",
    "IT decision",
    "Itransition",
    "JUKA-Invest",
    "Maize",
    "MIRS (MELDO INTERNATIONAL ROUTING SERVICES)",
    "Monolead",
    "Orphy Telecom",
    "OXNP GROUP LLC",
    "Pipl",
    "RDNK Immigration",
    "Remba (UMI)",
    "Teliqon",
    "UniTalk",
    "Universal Call",
    "Ventbazar",
    "Ventbazar plus",
    "Wellamart",
    "XO Corparation",
    "Вест-ТВ (homenetit)",
    "ssofice_ru_fix",
    "02 voip LLC",
  ];

  const initialTemplates = {
    A1: {
      id: "A1",
      shortName: "A1",
      name: "A1 Telecom LLC",
      address: "Bukhaidze str. 22, Kutaisi, Georgia",
      bank: "Privatbank",
      card: "4149609041462039",
      beneficiaryName: "A1 Telecom LLC",
      beneficiaryAddress: "Bukhaidze str. 22, Kutaisi, Georgia",
      beneficiaryBank: "Paysera LT, UAB",
      beneficiaryBankAddress: "Pilaitės pr. 16, Vilnius, LT-04352, Lithuania",
      beneficiaryIban: "LT543500010005478882",
      swift: "EVIULT2VXXX",
      bankAccountNote: "The updated list of correspondent banks will be provided with each payment request.",
      note: "valid for three days from the invoice date",
      logo: "A1_LOGO.png",
      cryptoNetwork: "TRC20",
      cryptoAddress: "TD2YbiFpNLbKEtciTtMq41A5BnwCNp3Rtt",
    },
    TIS: {
      id: "TIS",
      shortName: "TIS",
      name: "Telecommunication Information Systems",
      address: "Mannimatsa 19, Parnu, Estonia(80042)",
      bank: "HOLVI PAYMENT SERVICES LTD",
      bankAddress: "27-29 TEHTAANKATU, HELSINKI, 00150, Finland",
      swift: "HOLVFIHH",
      iban: "FI4879977990144284",
      bankAccountNote: "Only for EUR",
      card: "",
      note: "",
      logo: "TIS_LOGO.png",
      cryptoNetwork: "TRC20",
      cryptoAddress: "TD2YbiFpNLbKEtciTtMq41A5BnwCNp3Rtt",
    },
  };

  const [companyData, setCompanyData] = useState(initialTemplates);
  const [selectedCompany, setSelectedCompany] = useState("A1");

  const [invoiceData, setInvoiceData] = useState({
    invoiceNumber: `INV-${new Date().toISOString().split("T")[0].replaceAll("-", "")}`,
    date: new Date().toISOString().slice(0, 10),
    clientName: "Гарбузов Михаил",
    clientAddress: "Украина",
    items: [{ description: "For Telecommunication Services", amount: 100 }],
    currency: "UAH",
    paymentMethod: "Card",
  });

  // --- helpers to update state ---
  function updateCompanyField(companyKey, field, value) {
    setCompanyData((prev) => ({ ...prev, [companyKey]: { ...prev[companyKey], [field]: value } }));
  }
  function updateInvoiceField(field, value) {
    setInvoiceData((prev) => ({ ...prev, [field]: value }));
  }
  function updateItem(idx, key, value) {
    setInvoiceData((prev) => {
      const items = prev.items.slice();
      items[idx] = { ...items[idx], [key]: key === "amount" ? Number(value) : value };
      return { ...prev, items };
    });
  }
  function addItem() {
    setInvoiceData((prev) => ({ ...prev, items: [...prev.items, { description: "", amount: 0 }] }));
  }
  function removeItem(idx) {
    setInvoiceData((prev) => ({ ...prev, items: prev.items.filter((_, i) => i !== idx) }));
  }
  function resetItems() {
    setInvoiceData((prev) => ({ ...prev, items: [{ description: "For Telecommunication Services", amount: 100 }] }));
  }

  const total = invoiceData.items.reduce((s, i) => s + (Number(i.amount) || 0), 0);
  const currentCompany = companyData[selectedCompany];

  function sanitizeFileName(s) {
    return s.replace(/[\\/:"*?<>|]+/g, "").trim();
  }

  function getFileBaseName() {
    const d = new Date(invoiceData.date);
    const dd = String(d.getDate()).padStart(2, "0");
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const companyForName = sanitizeFileName(currentCompany.name);
    return `invoice for ${companyForName} ${dd}.${mm}`;
  }

  // ---------- Export PDF ----------
  async function exportPDF() {
    const node = pdfRef.current;
    if (!node) return;
    
    const [{ default: html2canvas }, { jsPDF }] = await Promise.all([import("html2canvas"), import("jspdf")]);

    const canvas = await html2canvas(node, { 
      scale: 2, 
      useCORS: true,
      width: node.scrollWidth,
      height: node.scrollHeight
    });
    
    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF({ orientation: "portrait", unit: "pt", format: "a4" });
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();
    const imgProps = { width: canvas.width, height: canvas.height };
    const ratio = Math.min(pageWidth / imgProps.width, pageHeight / imgProps.height);
    const imgWidth = imgProps.width * ratio;
    const imgHeight = imgProps.height * ratio;
    const x = (pageWidth - imgWidth) / 2;
    pdf.addImage(imgData, "PNG", x, 20, imgWidth, imgHeight);
    pdf.save(`${getFileBaseName()}.pdf`);
  }

  // ---------- Export DOCX ----------
  async function exportDOCX() {
    const docx = await import("docx");
    const { saveAs } = await import("file-saver");
    const {
      Document,
      Packer,
      Paragraph,
      TextRun,
      Table,
      TableRow,
      TableCell,
      WidthType,
      AlignmentType,
      ImageRun,
    } = docx;

    const logoUrl = `/${currentCompany.logo}`;
    let imageBuffer = null;
    try {
      const resp = await fetch(logoUrl);
      if (resp.ok) imageBuffer = await resp.arrayBuffer();
    } catch (e) {
      imageBuffer = null;
    }

    const children = [];

    if (selectedCompany === "A1") {
      children.push(
        new Paragraph({
          children: imageBuffer ? [new ImageRun({ data: imageBuffer, transformation: { width: 120, height: 100 } })] : [new TextRun("")],
          alignment: AlignmentType.LEFT,
        })
      );
      children.push(new Paragraph({ children: [new TextRun({ text: currentCompany.name, bold: true, size: 28 })], alignment: AlignmentType.RIGHT }));
      children.push(new Paragraph({ text: currentCompany.address, alignment: AlignmentType.RIGHT }));
      children.push(new Paragraph(""));
      children.push(
        new Paragraph({
          children: [new TextRun({ text: `INVOICE ${selectedCompany}${invoiceData.date.replaceAll("-", "")}`, bold: true })],
          alignment: AlignmentType.CENTER,
        })
      );
      children.push(new Paragraph({ text: `Date: ${invoiceData.date}`, alignment: AlignmentType.RIGHT }));
      children.push(new Paragraph(""));
      children.push(new Paragraph({ children: [new TextRun({ text: "Name: ", bold: true }), new TextRun(invoiceData.clientName)] }));
      children.push(new Paragraph({ children: [new TextRun({ text: "Address: ", bold: true }), new TextRun(invoiceData.clientAddress)] }));
      children.push(new Paragraph(""));

      const headerRow = new TableRow({
        children: [
          new TableCell({ width: { size: 70, type: WidthType.PERCENTAGE }, children: [new Paragraph({ children: [new TextRun({ text: "Item", bold: true })] })] }),
          new TableCell({ width: { size: 30, type: WidthType.PERCENTAGE }, children: [new Paragraph({ children: [new TextRun({ text: `Amount, ${invoiceData.currency}`, bold: true })] })] }),
        ],
      });
      const itemRows = invoiceData.items.map((it) => new TableRow({ children: [new TableCell({ children: [new Paragraph(it.description || "")] }), new TableCell({ children: [new Paragraph(String(it.amount || 0))] })] }));
      const totalRow = new TableRow({
        children: [
          new TableCell({ children: [new Paragraph({ children: [new TextRun({ text: "TOTAL AMOUNT", bold: true })] })] }),
          new TableCell({ children: [new Paragraph({ children: [new TextRun({ text: `${total} ${invoiceData.currency}`, bold: true })] })] }),
        ],
      });

      children.push(new Table({ rows: [headerRow, ...itemRows, totalRow], width: { size: 100, type: WidthType.PERCENTAGE } }));
      children.push(new Paragraph(""));

      if (invoiceData.paymentMethod === "Crypto") {
        children.push(new Paragraph({ children: [new TextRun({ text: "Payment should be directed to:", bold: true })] }));
        children.push(new Paragraph({ children: [new TextRun({ text: currentCompany.cryptoNetwork || "" })] }));
        children.push(new Paragraph({ children: [new TextRun({ text: currentCompany.cryptoAddress || "" })] }));
      } else if (invoiceData.paymentMethod === "Card") {
        children.push(new Paragraph({ children: [new TextRun({ text: "Payment should be directed to:", bold: true })] }));
        children.push(new Paragraph({ children: [new TextRun({ text: `Bank: ${currentCompany.bank || ""}` })] }));
        children.push(new Paragraph({ children: [new TextRun({ text: `Card: ${currentCompany.card || ""}` })] }));
      } else if (invoiceData.paymentMethod === "Bank Transfer") {
        const bankRowsA1 = [
          new TableRow({ children: [new TableCell({ children: [new Paragraph({ children: [new TextRun({ text: "Bank details", bold: true })] })], columnSpan: 2 })] }),
          new TableRow({ children: [new TableCell({ children: [new Paragraph({ children: [new TextRun({ text: "Beneficiary Name", bold: true })] })] }), new TableCell({ children: [new Paragraph(currentCompany.beneficiaryName || "")] })] }),
          new TableRow({ children: [new TableCell({ children: [new Paragraph({ children: [new TextRun({ text: "Beneficiary Address", bold: true })] })] }), new TableCell({ children: [new Paragraph(currentCompany.beneficiaryAddress || "")] })] }),
          new TableRow({ children: [new TableCell({ children: [new Paragraph({ children: [new TextRun({ text: "Beneficiary Bank", bold: true })] })] }), new TableCell({ children: [new Paragraph(currentCompany.beneficiaryBank || "")] })] }),
          new TableRow({ children: [new TableCell({ children: [new Paragraph({ children: [new TextRun({ text: "Beneficiary Bank Address", bold: true })] })] }), new TableCell({ children: [new Paragraph(currentCompany.beneficiaryBankAddress || "")] })] }),
          new TableRow({ children: [new TableCell({ children: [new Paragraph({ children: [new TextRun({ text: "Beneficiary IBAN", bold: true })] })] }), new TableCell({ children: [new Paragraph(currentCompany.beneficiaryIban || "")] })] }),
          new TableRow({ children: [new TableCell({ children: [new Paragraph({ children: [new TextRun({ text: "SWIFT Code", bold: true })] })] }), new TableCell({ children: [new Paragraph(currentCompany.swift || "")] })] }),
          new TableRow({ children: [new TableCell({ children: [new Paragraph({ children: [new TextRun({ text: "Note", bold: true })] })] }), new TableCell({ children: [new Paragraph(currentCompany.bankAccountNote || "")] })] }),
        ];
        children.push(new Paragraph(""));
        children.push(new Paragraph(""));
        children.push(new Paragraph(""));
        children.push(new Paragraph(""));
        children.push(new Paragraph(""));
        children.push(new Paragraph(""));
        children.push(new Paragraph(""));
        children.push(new Table({ rows: bankRowsA1, width: { size: 100, type: WidthType.PERCENTAGE } }));
      } else {
        children.push(new Paragraph({ children: [new TextRun({ text: "Payment should be directed to:", bold: true })] }));
        if (currentCompany.bank) children.push(new Paragraph({ children: [new TextRun({ text: `Bank: ${currentCompany.bank}` })] }));
        if (currentCompany.card) children.push(new Paragraph({ children: [new TextRun({ text: `Card: ${currentCompany.card}` })] }));
      }
      children.push(new Paragraph(""));
      if (currentCompany.note) children.push(new Paragraph({ children: [new TextRun({ text: currentCompany.note, bold: true })] }));
    }

    if (selectedCompany === "TIS") {
      children.push(
        new Paragraph({
          children: imageBuffer ? [new ImageRun({ data: imageBuffer, transformation: { width: 140, height: 70 } })] : [new TextRun("")],
          alignment: AlignmentType.LEFT,
        })
      );
      children.push(new Paragraph({ children: [new TextRun({ text: `Name: ${currentCompany.name}`, bold: true })], alignment: AlignmentType.RIGHT }));
      children.push(new Paragraph({ text: `Address: ${currentCompany.address}`, alignment: AlignmentType.RIGHT }));
      children.push(new Paragraph(""));
      children.push(new Paragraph({ children: [new TextRun({ text: `INVOICE ${invoiceData.invoiceNumber || invoiceData.date.replaceAll("-", "")}`, bold: true })], alignment: AlignmentType.CENTER }));
      children.push(new Paragraph(""));
      children.push(new Paragraph({ children: [new TextRun({ text: `Name: ${invoiceData.clientName}`, bold: true })], alignment: AlignmentType.LEFT }));
      children.push(new Paragraph({ children: [new TextRun({ text: `Date: ${invoiceData.date}` })], alignment: AlignmentType.RIGHT }));
      children.push(new Paragraph({ children: [new TextRun({ text: `Address: ${invoiceData.clientAddress}` })], alignment: AlignmentType.LEFT }));
      children.push(new Paragraph({ children: [new TextRun({ text: `Billing cycle: ${invoiceData.date}` })], alignment: AlignmentType.RIGHT }));
      children.push(new Paragraph(""));

      const headerRowT = new TableRow({
        children: [
          new TableCell({ width: { size: 80, type: WidthType.PERCENTAGE }, children: [new Paragraph({ children: [new TextRun({ text: "Item", bold: true })] })] }),
          new TableCell({ width: { size: 20, type: WidthType.PERCENTAGE }, children: [new Paragraph({ children: [new TextRun({ text: `Amount, ${invoiceData.currency}`, bold: true })] })] }),
        ],
      });
      const itemRowsT = invoiceData.items.map((it) => new TableRow({ children: [new TableCell({ children: [new Paragraph(it.description || "")] }), new TableCell({ children: [new Paragraph(String(it.amount || 0))] })] }));
      const totalRowT = new TableRow({
        children: [
          new TableCell({ children: [new Paragraph({ children: [new TextRun({ text: `TOTAL AMOUNT (${invoiceData.currency})`, bold: true })] })] }),
          new TableCell({ children: [new Paragraph(String(total || 0))] }),
        ],
      });
      children.push(new Table({ rows: [headerRowT, ...itemRowsT, totalRowT], width: { size: 100, type: WidthType.PERCENTAGE } }));

      children.push(new Paragraph(""));
      children.push(new Paragraph(""));

      if (invoiceData.paymentMethod === "Crypto") {
        children.push(new Paragraph({ children: [new TextRun({ text: "Payment should be directed to:", bold: true })] }));
        children.push(new Paragraph({ children: [new TextRun({ text: currentCompany.cryptoNetwork || "" })] }));
        children.push(new Paragraph({ children: [new TextRun({ text: currentCompany.cryptoAddress || "" })] }));
      } else if (invoiceData.paymentMethod === "Card") {
        children.push(new Paragraph({ children: [new TextRun({ text: "Payment should be directed to:", bold: true })] }));
        children.push(new Paragraph({ children: [new TextRun({ text: `Bank: ${currentCompany.bank || ""}` })] }));
        if (currentCompany.card) {
          children.push(new Paragraph({ children: [new TextRun({ text: `Card: ${currentCompany.card}` })] }));
        }
      } else {
        const bankRows = [
          new TableRow({ children: [new TableCell({ children: [new Paragraph({ children: [new TextRun({ text: "Bank details", bold: true })] })], columnSpan: 2 })] }),
          new TableRow({ children: [new TableCell({ children: [new Paragraph({ children: [new TextRun({ text: "Address", bold: true })] })] }), new TableCell({ children: [new Paragraph(currentCompany.bankAddress || "")] })] }),
          new TableRow({ children: [new TableCell({ children: [new Paragraph({ children: [new TextRun({ text: "Bank", bold: true })] })] }), new TableCell({ children: [new Paragraph(currentCompany.bank || "")] })] }),
          new TableRow({ children: [new TableCell({ children: [new Paragraph({ children: [new TextRun({ text: "SWIFT", bold: true })] })] }), new TableCell({ children: [new Paragraph(currentCompany.swift || "")] })] }),
          new TableRow({ children: [new TableCell({ children: [new Paragraph({ children: [new TextRun({ text: "IBAN", bold: true })] })] }), new TableCell({ children: [new Paragraph(currentCompany.iban || "")] })] }),
          new TableRow({ children: [new TableCell({ children: [new Paragraph({ children: [new TextRun({ text: "Bank account", bold: true })] })] }), new TableCell({ children: [new Paragraph(currentCompany.bankAccountNote || "")] })] }),
        ];
        children.push(new Paragraph(""));
        children.push(new Paragraph(""));
        children.push(new Paragraph(""));
        children.push(new Paragraph(""));
        children.push(new Paragraph(""));
        children.push(new Paragraph(""));
        children.push(new Paragraph(""));
        children.push(new Paragraph(""));
        children.push(new Table({ rows: bankRows, width: { size: 100, type: WidthType.PERCENTAGE } }));
      }
    }

    const doc = new Document({ sections: [{ properties: {}, children }] });
    const blob = await Packer.toBlob(doc);
    saveAs(blob, `${getFileBaseName()}.docx`);
  }

  // ---------- Условный рендеринг ----------
  if (isLoading) {
    return <div>Проверка доступа...</div>;
  }

  if (!isAuthorized) {
    return null;
  }

  // ---------- UI ----------
  return (
    <div className="p-6 bg-gray-50 min-h-screen">
      <style jsx>{`
        .pdf-table td, .pdf-table th {
          padding: 12px 8px !important;
          line-height: 1.4 !important;
          vertical-align: top !important;
          height: 24px !important;
          min-height: 24px !important;
        }
        .pdf-table input {
          padding: 4px !important;
          line-height: 1.2 !important;
          height: auto !important;
          border: none !important;
          background: transparent !important;
        }
        .bank-details-spacing {
          margin-top: 32px !important;
          margin-bottom: 32px !important;
        }
        @media print {
          .no-export { display: none !important; }
        }
      `}</style>
      
      <div className="max-w-6xl mx-auto">
        <h1 className="text-2xl font-semibold mb-4">Генератор инвойсов</h1>

        <div className="grid grid-cols-3 gap-6">
          {/* Left panel — настройки */}
          <div className="col-span-1 bg-white p-4 rounded shadow">
            <label className="block font-medium">Компания</label>
            <select className="w-full border p-2 rounded mt-2" value={selectedCompany} onChange={(e) => setSelectedCompany(e.target.value)}>
              <option value="A1">A1 Telecom LLC</option>
              <option value="TIS">TIS (Telecommunication Information Systems)</option>
            </select>

            <hr className="my-4" />

            <label className="block font-medium">Номер инвойса</label>
            <input className="w-full border p-2 rounded mt-2" value={invoiceData.invoiceNumber} onChange={(e) => updateInvoiceField("invoiceNumber", e.target.value)} />

            <label className="block font-medium mt-3">Дата</label>
            <input type="date" className="w-full border p-2 rounded mt-2" value={invoiceData.date} onChange={(e) => updateInvoiceField("date", e.target.value)} />

            <label className="block font-medium mt-3">Клиент — выберите из списка или введите вручную</label>
            <input
              list="clients-list"
              className="w-full border p-2 rounded mt-2"
              value={invoiceData.clientName}
              onChange={(e) => updateInvoiceField("clientName", e.target.value)}
            />
            <datalist id="clients-list">
              {clientsList.map((c, i) => (
                <option key={i} value={c} />
              ))}
            </datalist>

            <label className="block font-medium mt-3">Адрес клиента</label>
            <input className="w-full border p-2 rounded mt-2" value={invoiceData.clientAddress} onChange={(e) => updateInvoiceField("clientAddress", e.target.value)} />

            <label className="block font-medium mt-3">Способ оплаты</label>
            <select className="w-full border p-2 rounded mt-2" value={invoiceData.paymentMethod} onChange={(e) => updateInvoiceField("paymentMethod", e.target.value)}>
              <option>Card</option>
              <option>Bank Transfer</option>
              <option>PayPal</option>
              <option>Cash</option>
              <option>Crypto</option>
            </select>

            {invoiceData.paymentMethod === "Crypto" && (
              <div className="mt-3">
                <label className="block text-sm font-medium">Сеть (Network)</label>
                <input className="w-full border p-2 rounded mt-1" value={currentCompany.cryptoNetwork} onChange={(e) => updateCompanyField(selectedCompany, "cryptoNetwork", e.target.value)} />
                <label className="block text-sm font-medium mt-2">Кошелёк (Wallet Address)</label>
                <input className="w-full border p-2 rounded mt-1" value={currentCompany.cryptoAddress} onChange={(e) => updateCompanyField(selectedCompany, "cryptoAddress", e.target.value)} />
              </div>
            )}

            <label className="block font-medium mt-3">Валюта</label>
            <select className="w-full border p-2 rounded mt-2" value={invoiceData.currency} onChange={(e) => updateInvoiceField("currency", e.target.value)}>
              <option value="UAH">UAH</option>
              <option value="USD">USD</option>
              <option value="EUR">EUR</option>
            </select>

            <div className="mt-4">
              <button className="px-4 py-2 bg-blue-600 text-white rounded mr-2" onClick={exportPDF}>
                Скачать PDF
              </button>
              <button className="px-4 py-2 bg-green-600 text-white rounded" onClick={exportDOCX}>
                Скачать DOCX
              </button>
            </div>
          </div>

          {/* Right area — preview and editing */}
          <div className="col-span-2">
            <div className="bg-white p-4 rounded shadow">
              <div className="flex justify-between items-start mb-4">
                <div>
                  <div className="text-lg font-bold">Редактирование шаблона: {companyData[selectedCompany].name}</div>
                  <div className="text-sm text-gray-600">
                    Адрес:
                    <input className="border p-1 rounded ml-2" value={companyData[selectedCompany].address} onChange={(e) => updateCompanyField(selectedCompany, "address", e.target.value)} />
                  </div>
                </div>
                <div className="text-right">
                  <div className="text-sm">
                    Банк:
                    <input className="border p-1 rounded ml-2" value={companyData[selectedCompany].bank || ""} onChange={(e) => updateCompanyField(selectedCompany, "bank", e.target.value)} />
                  </div>
                  <div className="text-sm mt-1">
                    Карта / IBAN:
                    <input
                      className="border p-1 rounded ml-2"
                      value={companyData[selectedCompany].card || companyData[selectedCompany].iban || companyData[selectedCompany].beneficiaryIban || ""}
                      onChange={(e) => {
                        if (selectedCompany === "TIS") updateCompanyField(selectedCompany, "iban", e.target.value);
                        else updateCompanyField(selectedCompany, "card", e.target.value);
                      }}
                    />
                  </div>
                  {(selectedCompany === "TIS" || selectedCompany === "A1") && (
                    <div className="text-sm mt-1">
                      SWIFT:
                      <input className="border p-1 rounded ml-2" value={companyData[selectedCompany].swift || ""} onChange={(e) => updateCompanyField(selectedCompany, "swift", e.target.value)} />
                    </div>
                  )}
                </div>
              </div>

              {/* PREVIEW (С Actions) */}
              <div ref={previewRef} className="p-6 border rounded bg-white mb-4">
                <div className="flex justify-between items-start">
                  <div>
                    <img src={`/${companyData[selectedCompany].logo}`} alt="logo" className="h-16 mb-2" />
                    <div className="text-2xl font-bold">{companyData[selectedCompany].name}</div>
                    <div className="text-sm">{companyData[selectedCompany].address}</div>
                  </div>
                  <div className="text-right">
                    <div className="text-sm">
                      Invoice: <strong>{invoiceData.invoiceNumber}</strong>
                    </div>
                    <div className="text-sm">Date: {invoiceData.date}</div>
                  </div>
                </div>

                <hr className="my-4" />

                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <div className="text-sm text-gray-600">Bill To:</div>
                    <div className="font-medium">{invoiceData.clientName}</div>
                    <div className="text-sm">{invoiceData.clientAddress}</div>
                  </div>
                  <div className="text-right">
                    <div className="text-sm">Payment method: {invoiceData.paymentMethod}</div>
                    {invoiceData.paymentMethod === "Crypto" ? (
                      <>
                        <div className="text-sm">Network: {companyData[selectedCompany].cryptoNetwork}</div>
                        <div className="text-sm break-all">Wallet: {companyData[selectedCompany].cryptoAddress}</div>
                      </>
                    ) : invoiceData.paymentMethod === "Card" ? (
                      <>
                        <div className="text-sm">Bank: {companyData[selectedCompany].bank || ""}</div>
                        {companyData[selectedCompany].card && (
                          <div className="text-sm">Card: {companyData[selectedCompany].card}</div>
                        )}
                      </>
                    ) : invoiceData.paymentMethod === "Bank Transfer" ? (
                      <>
                        {selectedCompany === "A1" ? (
                          <>
                            <div className="text-sm">Beneficiary Name: {companyData[selectedCompany].beneficiaryName}</div>
                            <div className="text-sm">Beneficiary Address: {companyData[selectedCompany].beneficiaryAddress}</div>
                            <div className="text-sm">Beneficiary Bank: {companyData[selectedCompany].beneficiaryBank}</div>
                            <div className="text-sm">Beneficiary Bank Address: {companyData[selectedCompany].beneficiaryBankAddress}</div>
                            <div className="text-sm">Beneficiary IBAN: {companyData[selectedCompany].beneficiaryIban}</div>
                            <div className="text-sm">SWIFT Code: {companyData[selectedCompany].swift}</div>
                            <div className="text-sm text-gray-600">{companyData[selectedCompany].bankAccountNote}</div>
                            <div className="bank-details-spacing"></div>
                          </>
                        ) : (
                          <>
                            <div className="text-sm">Bank: {companyData[selectedCompany].bank}</div>
                            <div className="text-sm">IBAN: {companyData[selectedCompany].iban}</div>
                            <div className="text-sm">SWIFT: {companyData[selectedCompany].swift}</div>
                            <div className="bank-details-spacing"></div>
                          </>
                        )}
                      </>
                    ) : (
                      <>
                        <div className="text-sm">Bank: {companyData[selectedCompany].bank}</div>
                        <div className="text-sm">Card/IBAN: {companyData[selectedCompany].card || companyData[selectedCompany].iban || companyData[selectedCompany].beneficiaryIban || ""}</div>
                        {selectedCompany === "TIS" && <div className="text-sm">SWIFT: {companyData[selectedCompany].swift || ""}</div>}
                      </>
                    )}
                  </div>
                </div>

                <table className="w-full mt-6 table-fixed border-collapse border">
                  <thead>
                    <tr className="text-left border-b">
                      <th className="py-3">Item</th>
                      <th className="py-3 text-right">Amount ({invoiceData.currency})</th>
                      <th className="py-3 text-center">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {invoiceData.items.map((it, idx) => (
                      <tr key={idx} className="border-b">
                        <td className="py-3 align-top">
                          <input className="w-full" value={it.description} onChange={(e) => updateItem(idx, "description", e.target.value)} />
                        </td>
                        <td className="py-3 text-right align-top">
                          <input className="w-28 text-right" value={it.amount} onChange={(e) => updateItem(idx, "amount", e.target.value)} />
                        </td>
                        <td className="py-3 text-center align-top">
                          <button className="px-2 py-1 text-sm border rounded" onClick={() => removeItem(idx)}>
                            Удалить
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                  <tfoot>
                    <tr>
                      <td className="pt-4 font-semibold">Total</td>
                      <td className="pt-4 text-right font-semibold">
                        {total} {invoiceData.currency}
                      </td>
                      <td />
                    </tr>
                  </tfoot>
                </table>

                <div className="mt-4 text-sm text-gray-600">{companyData[selectedCompany].note}</div>
              </div>

              {/* PDF VARIANT (БЕЗ Actions + УВЕЛИЧЕННАЯ ВЫСОТА + ОТСТУП ДЛЯ Bank Transfer) */}
              <div ref={pdfRef} className="p-6 border rounded bg-white pdf-export">
                <div className="flex justify-between items-start">
                  <div>
                    <img src={`/${companyData[selectedCompany].logo}`} alt="logo" className="h-16 mb-2" />
                    <div className="text-2xl font-bold">{companyData[selectedCompany].name}</div>
                    <div className="text-sm">{companyData[selectedCompany].address}</div>
                  </div>
                  <div className="text-right">
                    <div className="text-sm">
                      Invoice: <strong>{invoiceData.invoiceNumber}</strong>
                    </div>
                    <div className="text-sm">Date: {invoiceData.date}</div>
                  </div>
                </div>

                <hr className="my-4" />

                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <div className="text-sm text-gray-600">Bill To:</div>
                    <div className="font-medium">{invoiceData.clientName}</div>
                    <div className="text-sm">{invoiceData.clientAddress}</div>
                  </div>
                  <div className="text-right">
                    <div className="text-sm">Payment method: {invoiceData.paymentMethod}</div>
                    {invoiceData.paymentMethod === "Crypto" ? (
                      <>
                        <div className="text-sm">Network: {companyData[selectedCompany].cryptoNetwork}</div>
                        <div className="text-sm break-all">Wallet: {companyData[selectedCompany].cryptoAddress}</div>
                      </>
                    ) : invoiceData.paymentMethod === "Card" ? (
                      <>
                        <div className="text-sm">Bank: {companyData[selectedCompany].bank || ""}</div>
                        {companyData[selectedCompany].card && (
                          <div className="text-sm">Card: {companyData[selectedCompany].card}</div>
                        )}
                      </>
                    ) : invoiceData.paymentMethod === "Bank Transfer" ? (
                      <>
                        {selectedCompany === "A1" ? (
                          <>
                            <div className="text-sm">Beneficiary Name: {companyData[selectedCompany].beneficiaryName}</div>
                            <div className="text-sm">Beneficiary Address: {companyData[selectedCompany].beneficiaryAddress}</div>
                            <div className="text-sm">Beneficiary Bank: {companyData[selectedCompany].beneficiaryBank}</div>
                            <div className="text-sm">Beneficiary Bank Address: {companyData[selectedCompany].beneficiaryBankAddress}</div>
                            <div className="text-sm">Beneficiary IBAN: {companyData[selectedCompany].beneficiaryIban}</div>
                            <div className="text-sm">SWIFT Code: {companyData[selectedCompany].swift}</div>
                            <div className="text-sm text-gray-600">{companyData[selectedCompany].bankAccountNote}</div>
                            <div className="bank-details-spacing"></div>
                          </>
                        ) : (
                          <>
                            <div className="text-sm">Bank: {companyData[selectedCompany].bank}</div>
                            <div className="text-sm">IBAN: {companyData[selectedCompany].iban}</div>
                            <div className="text-sm">SWIFT: {companyData[selectedCompany].swift}</div>
                            <div className="bank-details-spacing"></div>
                          </>
                        )}
                      </>
                    ) : (
                      <>
                        <div className="text-sm">Bank: {companyData[selectedCompany].bank}</div>
                        <div className="text-sm">Card/IBAN: {companyData[selectedCompany].card || companyData[selectedCompany].iban || companyData[selectedCompany].beneficiaryIban || ""}</div>
                        {selectedCompany === "TIS" && <div className="text-sm">SWIFT: {companyData[selectedCompany].swift || ""}</div>}
                      </>
                    )}
                  </div>
                </div>

                <table className="w-full mt-6 pdf-table table-fixed border-collapse border">
                  <thead>
                    <tr className="text-left border-b">
                      <th className="pdf-table">Item</th>
                      <th className="pdf-table text-right">Amount ({invoiceData.currency})</th>
                    </tr>
                  </thead>
                  <tbody>
                    {invoiceData.items.map((it, idx) => (
                      <tr key={idx} className="border-b">
                        <td className="pdf-table">{it.description}</td>
                        <td className="pdf-table text-right">{it.amount}</td>
                      </tr>
                    ))}
                  </tbody>
                  <tfoot>
                    <tr>
                      <td className="pt-4 font-semibold">Total</td>
                      <td className="pt-4 text-right font-semibold">
                        {total} {invoiceData.currency}
                      </td>
                    </tr>
                  </tfoot>
                </table>

                <div className="mt-4 text-sm text-gray-600">{companyData[selectedCompany].note}</div>
              </div>

              {/* Actions for items */}
              <div className="mt-4 flex gap-2">
                <button className="px-3 py-1 border rounded" onClick={addItem}>
                  Добавить позицию
                </button>
                <button className="px-3 py-1 border rounded" onClick={resetItems}>
                  Сбросить позиции
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}